import { render, staticRenderFns } from "./ContratoEPIForm.vue?vue&type=template&id=38252e4d&"
import script from "./ContratoEPIForm.vue?vue&type=script&lang=js&"
export * from "./ContratoEPIForm.vue?vue&type=script&lang=js&"
import style0 from "./ContratoEPIForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ContratoEPIForm.vue"
export default component.exports